import state from "./state"

export default {
    getSavedLocation  : (state) => state.latitude
}
